<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2" xl="6">
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && profile != null">
          <!-- <v-breadcrumbs class="pl-0 pb-0" :items="bc" large></v-breadcrumbs> -->
          <v-row style="justify-content: center">
            <v-col cols="12" lg="9">
              <!-- <div class="headline mb-4">Discussion Board</div> -->

              <timeline-poster ref="poster"></timeline-poster>

              <v-sheet rounded elevation="1" class="py-0">
                <div
                  class="d-flex align-center hoverable pa-2"
                  @click="$refs.poster.open()"
                >
                  <div class="flex-grow-1 py-0">
                    <div>
                      <v-list-item class="pl-2 py-0">
                        <v-list-item-avatar>
                          <v-avatar>
                            <img :src="$userInfo.image" alt />
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0"
                          ><v-list-item-title class="py-0">
                            <v-text-field
                              class="py-0"
                              label="What are you thinking?"
                              full-width
                              hide-details
                              disabled
                            ></v-text-field> </v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                </div>
              </v-sheet>

              <section class="timeline-items my-4">
                <timeline-item
                  :items="portfolio"
                  :posts="posts"
                ></timeline-item>
              </section>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CourseVerticalGridView from "@/components/CourseVerticalGridView.vue";
import TimelinePoster from "@/components/TimelinePoster.vue";
import TimelineItem from "@/components/TimelineItem.vue";
import Vue from "vue";

export default {
  components: {
    CourseVerticalGridView,
    TimelinePoster,
    TimelineItem,
  },
  data: () => ({
    showSkeleton: true,
    portfolio: [],
    allowPost: false,
    loading: false,
    profile: null,
    filter: 0,
    // url: 'https://api.nerdof.com/api',
    url: "http://localhost/api",
  }),
  computed: {
    courseId() {
      return this.$route.params.id;
    },
    bc() {
      return [
        {
          text: this.$utility.shortenText(
            "Cloud computing for neural networks. How to run Jupyter notebook with Tensorflow in the cloud",
            64
          ),
          to: {
            name: "course_detail",
            params: {
              id: this.$route.params.id,
            },
          },
        },
        {
          text: "Discussion",
          disabled: false,
        },
      ];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetch();
      // sample test
      this.portfolio = this.genSample();
    },
    genSample() {
      let samples = [];
      samples.push({
        text: "",
        type: "activity",
        content: {
          type: "lecture",
          text: "ได้เพิ่มบทเรียนใหม่",
          title: "บทที่ 5 กกกกกกกกกกกกกกกกกกกกก",
        },
        liked: 1,
        commentable: false,
      });

      let sample1 = {
        text: "Test message",
        type: "gallery",
        content: [],
        liked: 6,
        commentable: true,
      };
      for (let i = 0; i < 15; i++) {
        sample1.content.push(
          `https://picsum.photos/500/300?image=${i * 5 + 10}`
        );
      }
      samples.push(sample1);
      samples.push({
        text: "รอยยิ้มที่หัวใจ - ETC",
        type: "youtube",
        content: "https://www.youtube.com/watch?v=9xT-LuElxec",
        liked: 0,
        commentable: true,
      });

      samples.push({
        text: "",
        type: "activity",
        content: {
          type: "live",
          text: "กำลังเผยแพร่ภาพสด",
          cover: `https://picsum.photos/500/300?image=15`,
        },
        liked: 1,
        commentable: false,
      });
      return samples;
    },
    fetch() {
      this.profile = null;
      this.showSkeleton = true;
      const userInfo = Vue.prototype.$userInfo;
      this.$http
        .get(
          `${this.$store.state.api}/account/profile/teacher?id=${userInfo._id}`
        )
        .then((resp) => {
          if (resp.data.status == true) {
            this.profile = resp.data.result;
          } else {
            this.profile = null;
          }
        })
        .catch((err) => {
          this.profile = null;
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.post-container {
  border: 1px solid rgb(218, 218, 218);
}
</style>
